var cronosTrigger = "cronos";
export var IsCronosTriggerWargame = function (wargame, trigger) {
    if (trigger === cronosTrigger) {
        return wargame.trigger === cronosTrigger;
    }
    return wargame.trigger !== cronosTrigger;
};
export var isFailaConfig = function (config) { return config.isFailaConfig; };
export var isConfigDisabled = function (config) { return isFailaConfig(config); };
